import actionTypes from './SettingActionType'
import apiService from '../apiService'

export const getTheme = (param) => {
  return (dispatch) => {
    return apiService.get('rest/v1/getdetail_config', param).then((res) => {
      if (res.status) {
        dispatch(setTheme(res.data))
      } else {
        console.log('ERROR ACTION getTheme', res)
      }
    })
  }
}

export const setTheme = (data) => {
  return {
    type: actionTypes.SET_THEME,
    data
  }
}
